import React from "react";
import { FolderOutput, MessageSquareShare, Trash2 } from "lucide-react";
import MessageModal from "../Modal/MessageModal";
import DeleteModal from "../Modal/DeleteModal";
import { convertDateWithSlash } from "../../helpers";

export default function HighRiskPatientsDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    selectAll = false,
  } = props;

  return (
    <>
      {selectAll && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            <button className="docpro_bordered_btn docpro_fw_600 docpro_primary_color">
              <MessageSquareShare width={20} height={20} />
              Send Bulk SMS
            </button>
            <button className="docpro_bordered_btn docpro_fw_600 docpro_primary_color">
              <FolderOutput width={20} height={20} />
              Export Data
            </button>
            <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color">
              <Trash2 width={20} height={20} />
              Delete
            </button>
          </div>
        </>
      )}

      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && selectAll}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              <th>Last Name</th>
              <th>First Name</th>
              <th># of Conditions</th>
              <th>Date of Birth</th>
              <th>Gender</th>
              <th>Phone</th>
              <th>Insurance Name</th>
              <th>Last Visited</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData?.map((item, index) => (
              <tr key={index}>
                <td style={{ width: "45px" }}>
                  <div className="docpro_checkbox" style={{ top: "3px" }}>
                    <input
                      type="checkbox"
                      checked={item.checked || false}
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                    <label></label>
                  </div>
                </td>
                <td>
                  <img
                    src={item.avatarImgUrl}
                    alt=""
                    width={28}
                    height={28}
                    style={{
                      marginRight: "10px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                  {item.firstName}
                </td>
                <td>{item.lastName}</td>
                <td className="docpro_fw_700 docpro_primary_color">
                  {item.conditions}
                </td>
                <td>{convertDateWithSlash(item.dob)}</td>
                <td>{item.sex}</td>
                <td>{item.mobile_phone}</td>
                <td>
                  {item.insurance?.name || ""}
                </td>
                <td>{convertDateWithSlash(item.last_visit)}</td>
                <td className="docpro_text_center">
                  <div className="docpro_icon_btns">
                    <DeleteModal />
                    <MessageModal />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
